module.exports = __webpack_public_path__ + "static/img/2.e4fa2c73.jpg";